
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      var date = new Date();
var TommorowDay = date.setDate(date.getDate() + 1);
var Yesterday = date.setDate(date.getDate() - 1); //import css for availability and price pages

import '../css/new-reservation-home.css';
import $$ from 'Dom7';
import actions from '../js/actions.js';
import URLS from '../js/Urls.js';

var moment = require('moment');

var RoomsList;
var Sources;
var FilterRooms;
var NumberOfRooms = [];
var ratetext;
var totalRoomsPrice;
var labelRoomSelected;
var rompricr;
var pricemdl;
var priceroom;
var totalPriceStepper = 0;
var totalSelectedRooms = 0;
var RoomID = 0;
var checkinDatePrev;
var checkoutDatePrev;
var hasSelectedRoom = false;
var PaymentMethods = [];
var loginobject = {};
export default {
  data: function () {
    return {
      Rooms: {},
      Sources: {},
      BlockedRooms: {},
      BlockedRoomsComments: {},
      loginobject: {},
      NumberOfSelectedRooms: [],
      PaymentMethods: [],
      hasSelectedRoom: false
    };
  },

  beforeDestroy() {
    var self = this;
    $$('.toolbar-bottom').show();
  },

  methods: {
    toggleBox(index) {
      let icon = $$('#box-btn_' + index + ' .material-icons').eq(0);

      if (icon.text() === 'expand_less') {
        icon.text('expand_more');
        $$('#box_' + index).removeClass('expanded').addClass('collapsed');
      } else {
        icon.text('expand_less');
        $$('#box_' + index).removeClass('collapsed').addClass('expanded');
      }
    },

    calculateTotalPriceAndRooms() {
      var totalRooms = 0;
      var totalPrice = 0;
      var index = 0;
      NumberOfRooms.forEach(function (roomObject) {
        if (Object.keys(roomObject?.SelectedRoom || {}).length === 0) {
          return;
        }

        var selectedRate = roomObject.SelectedRoom.Rates[roomObject.SelectedRoom.selectedRateIndex !== undefined ? roomObject.SelectedRoom.selectedRateIndex : 0];
        totalPrice += selectedRate ? parseFloat(selectedRate.TotalPrice) : 0;
        totalRooms++;
        let totalPriceFormatted = parseFloat(selectedRate.TotalPrice) % 1 === 0 ? parseFloat(selectedRate.TotalPrice).toFixed(0) : parseFloat(selectedRate.TotalPrice).toFixed(2);
        let pricePerNightFormatted = parseFloat(selectedRate.PricePerNight) % 1 === 0 ? parseFloat(selectedRate.PricePerNight).toFixed(0) : parseFloat(selectedRate.PricePerNight).toFixed(2);
        let cleaningPriceFormatted = parseFloat(selectedRate.CleaningPrice) % 1 === 0 ? parseFloat(selectedRate.CleaningPrice).toFixed(0) : parseFloat(selectedRate.CleaningPrice).toFixed(2);
        let discountFormatted = parseFloat(selectedRate.Discount) % 1 === 0 ? parseFloat(selectedRate.Discount).toFixed(0) : parseFloat(selectedRate.Discount).toFixed(2);
        $$(`#roomprice_${index}_${roomObject.SelectedRoom.RoomTypeID}`).val(totalPriceFormatted);
        $$(`#roompriceday_${index}_${roomObject.SelectedRoom.RoomTypeID}`).val(pricePerNightFormatted);
        $$(`#roompriceclean_${index}_${roomObject.SelectedRoom.RoomTypeID}`).val(cleaningPriceFormatted);
        $$(`#roompricediscount_${index}_${roomObject.SelectedRoom.RoomTypeID}`).val(discountFormatted);
        $$(`#display-price_${index}_${roomObject.SelectedRoom.RoomTypeID}`).text(totalPriceFormatted);
        index++;
      });
      let totalPriceFormattedFinal = totalPrice % 1 === 0 ? totalPrice.toFixed(0) : totalPrice.toFixed(2);
      $$('#prall').text(totalPriceFormattedFinal);
      $$('#leball').text(totalRooms);
    },

    calculatePrices(index, isTotal) {
      const input = event.target;
      input.setAttribute('data-changeValue', 'false');
      let selectedRoom = NumberOfRooms[index].SelectedRoom;
      let selectedRate = selectedRoom.selectedRateIndex != undefined ? selectedRoom.Rates[selectedRoom.selectedRateIndex] : selectedRoom.Rates[0];
      let CalendarDateFrom = moment($$('#New-calendar-checkin').val(), 'DD/MM/YYYY');
      let CalendarDateTo = moment($$('#New-calendar-checkout').val(), 'DD/MM/YYYY');
      let nights = CalendarDateTo.diff(CalendarDateFrom, 'days');
      let cleaningPrice = parseFloat($$(`#roompriceclean_${index}_${selectedRoom.RoomTypeID}`).val()) || 0;
      let discountPercent = parseFloat($$(`#roompricediscount_${index}_${selectedRoom.RoomTypeID}`).val()) || 0;
      let newPrice = parseFloat($$(`#roomprice_${index}_${selectedRoom.RoomTypeID}`).val()) || 0;
      let pricePerNight = parseFloat($$(`#roompriceday_${index}_${selectedRoom.RoomTypeID}`).val()) || 0;
      pricePerNight = parseFloat(pricePerNight);
      let totalPrice = pricePerNight * nights;
      let discountPrice = pricePerNight * (discountPercent / 100) * nights;

      if (isTotal) {
        totalPrice = parseFloat(newPrice) || 0;
        discountPrice = totalPrice * (discountPercent / 100);
        pricePerNight = (totalPrice - cleaningPrice + discountPrice) / nights;
        pricePerNight = parseFloat(pricePerNight.toFixed(2));
      } else {
        totalPrice += cleaningPrice - discountPrice;
      }

      selectedRate.PricePerNight = pricePerNight;
      selectedRate.Discount = discountPercent;
      selectedRate.CleaningPrice = cleaningPrice;
      selectedRate.TotalPrice = totalPrice % 1 === 0 ? totalPrice.toFixed(0) : totalPrice.toFixed(2);
      this.calculateTotalPriceAndRooms();
    },

    updateHeroOpen(roomId, index) {
      var ratetext = $('.roomid_' + index + '_' + roomId + '.smart-select select option:selected').text();
      let selectedRoom = NumberOfRooms[index].SelectedRoom;
      let selectedRate = {};

      if (selectedRoom) {
        let selectedRateIndex = selectedRoom.Rates.findIndex(function (rateObj) {
          return rateObj.RateName == ratetext;
        }); // elegxos an exw vrei to selectedRate

        if (selectedRateIndex != -1) {
          selectedRate = selectedRoom.Rates[selectedRateIndex];
          selectedRoom.selectedRateIndex = selectedRateIndex; // var totalPrice = selectedRate.PricePerNight;
          // try {
          //     if (selectedRoom.allocatedRooms > 0) {
          //         totalPrice = selectedRate.PricePerNight * selectedRoom.allocatedRooms;
          //     }
          //     else {
          //         totalPrice = selectedRate.PricePerNight;
          //     }
          // } catch { }

          $$(`#roomprice_${index}_${selectedRoom.RoomTypeID}`).val(selectedRate.TotalPrice);
          $$(`#roompriceday_${index}_${selectedRoom.RoomTypeID}`).val(selectedRate.PricePerNight);
          $$(`#roompriceclean_${index}_${selectedRoom.RoomTypeID}`).val(selectedRate.CleaningPrice);
          $$(`#roompricediscount_${index}_${selectedRoom.RoomTypeID}`).val(selectedRate.Discount);
          $$(`#display-price_${index}_${selectedRoom.RoomTypeID}`).text(selectedRate.TotalPrice);
        }
      }

      this.calculateTotalPriceAndRooms();
    },

    updateRoomTypeFilter() {
      var roomId = $$('.roomtype.input-with-value').val();
      var selectedHtml = $$('#room-type-selector .item-content .item-after')[0].outerHTML;

      try {
        let selectedRoom = RoomsList.find(function (roomObj) {
          return roomObj.RoomTypeID == roomId;
        });
      } catch {}
    },

    async SearchOnChange() {
      $$('.searchbtn').click();
    },

    ShowRoom(Index) {
      $$('#hIndex').val(Index);
      $$('#clickme').click();
    },

    changeValueKeyUp(event) {
      const input = event.target;

      if (input.getAttribute('data-changeValue') === 'false') {
        input.value = event.key;
        input.setAttribute('data-changeValue', 'true');
      }
    },

    SetPaymenthMethod() {}

  },
  on: {
    pageInit: async function (e, page) {
      var self = this;
      var $ = self.$;
      actions.resetCustomerSearch();
      const loginobject = actions.LoginGetResult();
      const UserSpecificApiKey = loginobject?.PropertiesList?.find(property => property.PropertyName == loginobject?.PropertyName)?.UserSpecificApiKey;
      const Sources = await actions.GetPropertySources(loginobject.PropertyID);
      self.$setState({
        loginobject: loginobject,
        Sources: Sources
      });
      $$('#clickme').on('click', function () {
        var tmpIndex = $$('#hIndex').val();
        var Index = parseInt(tmpIndex);
        var RoomTypeID = parseInt($$('#room-cat-filter-selection_' + Index).val());
        let foundIndex = NumberOfRooms.findIndex(room => room.Index === Index);
        $$('#room-display-wapper_' + Index).hide();
        const prevRoomTypeID = NumberOfRooms[foundIndex]?.SelectedRoom?.RoomTypeID;

        if (foundIndex !== -1) {
          let filteredRoom = RoomsList?.find(room => room.RoomTypeID === RoomTypeID);
          NumberOfRooms[foundIndex].SelectedRoom = { ...filteredRoom
          };

          if (filteredRoom) {
            $$('#room-display-wapper_' + Index).show();
          }

          self.calculateTotalPriceAndRooms();
          self.$setState({
            NumberOfSelectedRooms: NumberOfRooms
          });
        }

        const selectedRooms = NumberOfRooms.filter(room => {
          const selectedRoom = room.SelectedRoom;
          return selectedRoom && Object.keys(selectedRoom).length > 0;
        });

        if (selectedRooms.length > 0) {
          self.$setState({
            hasSelectedRoom: true
          }).then(() => {
            const selectedRoom = NumberOfRooms[foundIndex].SelectedRoom;

            if (selectedRoom && selectedRoom.Rates && selectedRoom.Rates.length > 0) {
              const firstRate = selectedRoom.Rates[0];
              const firstValue = `${RoomTypeID}-${firstRate.RateID}-${firstRate.TotalPrice}`; // Set the smart-select value to the first rate

              const smartSelectInstance = $$('.roomid_' + Index + '_' + RoomTypeID);

              if (smartSelectInstance.length > 0) {
                $$('.roomid_' + Index + '_' + RoomTypeID + " .item-after").html(firstRate?.RateName);
              }
            }
          });
        } else {
          self.$setState({
            hasSelectedRoom: false
          });
        }

        if (prevRoomTypeID != RoomTypeID) {
          calculaterRooms();
        }
      });

      function calculaterRooms() {
        RoomsList.forEach(room => {
          room.allocatedRooms = 0;
        });
        NumberOfRooms.forEach(({
          SelectedRoom
        }) => {
          if (Object.keys(SelectedRoom).length === 0) {
            return;
          }

          const selectedRoomTypeID = SelectedRoom.RoomTypeID;
          const roomToUpdate = RoomsList.find(room => room.RoomTypeID === selectedRoomTypeID);

          if (roomToUpdate) {
            roomToUpdate.allocatedRooms++;
          }

          if (roomToUpdate.OccupiedRooms + roomToUpdate.allocatedRooms > roomToUpdate.TotalRooms) {
            roomToUpdate.IsAvailable = false;
          } else {
            roomToUpdate.IsAvailable = true;
          }

          roomToUpdate.TotalFree = roomToUpdate.TotalRooms - (roomToUpdate.OccupiedRooms + roomToUpdate.allocatedRooms);
          roomToUpdate.availableRooms = roomToUpdate.TotalFree;
          SelectedRoom = { ...roomToUpdate
          };
        });
        self.$setState({
          NumberOfSelectedRooms: NumberOfRooms
        });
      }

      $$('.currency-symbol').html(loginobject.Currency);

      function ChangeSegmented(id) {
        if (id == 1) {
          $$('#Guestbtn').addClass('button-active');
          $$('#Agencybtn').removeClass('button-active');
          $$('#Corporatebtn').removeClass('button-active');
        } else if (id == 2) {
          $$('#Guestbtn').removeClass('button-active');
          $$('#Agencybtn').addClass('button-active');
          $$('#Corporatebtn').removeClass('button-active');
        } else {
          $$('#Guestbtn').removeClass('button-active');
          $$('#Agencybtn').removeClass('button-active');
          $$('#Corporatebtn').addClass('button-active');
        }
      }

      $$('.smart-select-sheet').on('close', function () {
        var code = this;
      });
      $$('#ch').on('click', function () {});
      $('.page-current').on('change', '.checkbox', function () {});
      $$('input[type="checkbox]"').on('change click', function (ev) {});
      $$('#cancelbtn').on('click', () => {
        app.f7.views.main.router.navigate('/main/');
      });
      $$('.takecommentclass').on('change', function () {
        var blockedrooms = app.f7.smartSelect.get('.takecommentclass').getValue();
        blockedrooms = blockedrooms.replaceAll('_', ' ');
        $$('#blocktext').val(blockedrooms);
      });

      function ChangePrice() {
        var x = this;
      }

      var newrevObj = JSON.parse(localStorage.getItem('newRerv'));
      var today = moment();
      var tomorrow = moment(today).add(1, 'days');

      if (newrevObj) {
        RoomID = newrevObj.RoomID;

        if (newrevObj.DateFrom != '' && newrevObj.DateFrom != null) {
          today = moment(newrevObj.DateFrom, 'DD/MM/YYYY');
          tomorrow = moment(today).add(1, 'days');
          localStorage.setItem('newRerv', JSON.stringify(''));
        }
      }

      var calendarRangeFrom = app.f7.calendar.create({
        inputEl: '#New-calendar-checkin',
        dateFormat: 'dd/mm/yyyy',
        date: today,
        value: [today],
        closeOnSelect: true,
        disabled: [{
          from: new Date().minDate,
          to: today
        }],
        on: {
          close: function (c) {
            handleDateChange();
          }
        }
      });
      var calendarRangeTo = app.f7.calendar.create({
        inputEl: '#New-calendar-checkout',
        dateFormat: 'dd/mm/yyyy',
        date: tomorrow,
        value: [tomorrow],
        closeOnSelect: true,
        disabled: [{
          from: new Date().minDate,
          to: today
        }],
        on: {
          close: function (c) {
            handleDateChange();
            $$('.searchbtn').click();
          }
        }
      });

      function handleDateChange() {
        // Get the values of the check-in and check-out inputs using Moment.js
        var checkinDate = moment($$('#New-calendar-checkin').val(), 'DD/MM/YYYY');
        var checkoutDate = moment($$('#New-calendar-checkout').val(), 'DD/MM/YYYY');

        if (checkinDate.isSameOrAfter(checkoutDate)) {
          // Increment check-in date by one day
          checkinDate.add(1, 'days'); // Update check-out date to check-in + 1 day

          checkoutDate = moment(checkinDate); // Update the check-out calendar input

          calendarRangeTo.setValue([checkoutDate.toDate()]);
          $$('.searchbtn').click();
        }

        var disabledDates = [{
          from: null,
          to: checkinDate.clone().subtract(1, 'day')
        }];
        calendarRangeTo.params.disabled = disabledDates;
        calendarRangeTo.update(); // SearchOnOpen();
      }

      function handleDateChangeBlock() {
        var checkinDate = moment($$('#block-calendar-From').val(), 'DD/MM/YYYY');
        var checkoutDate = moment($$('#block-calendar-To').val(), 'DD/MM/YYYY');

        if (checkinDate.isSameOrAfter(checkoutDate)) {
          checkoutDate = checkinDate.clone().add(1, 'days');
        }

        if (calendarRangeTo2) {
          calendarRangeTo2.destroy();
        }

        calendarRangeTo2 = app.f7.calendar.create({
          inputEl: '#block-calendar-To',
          dateFormat: 'dd/mm/yyyy',
          date: checkoutDate.toDate(),
          value: [checkoutDate.toDate()],
          closeOnSelect: true,
          disabled: [{
            from: null,
            to: checkinDate.clone().subtract(1, 'day').toDate()
          }]
        });
        $$('#block-calendar-To').val(checkoutDate.format('DD/MM/YYYY'));
      }

      var calendarRangeFrom2 = app.f7.calendar.create({
        inputEl: '#block-calendar-From',
        dateFormat: 'dd/mm/yyyy',
        date: today,
        value: [today],
        closeOnSelect: true,
        on: {
          close: function () {
            handleDateChangeBlock();
          }
        }
      });
      var calendarRangeTo2 = app.f7.calendar.create({
        inputEl: '#block-calendar-To',
        dateFormat: 'dd/mm/yyyy',
        date: tomorrow,
        value: [tomorrow],
        closeOnSelect: true,
        disabled: [{
          from: null,
          to: today
        }]
      });
      var CalendarDateFrom = calendarRangeFrom2.getValue();
      var CalendarDateTo = calendarRangeTo2.getValue();

      async function SearchOnOpen(updateRoomFilter) {
        var CheckiInDate = moment($$('#New-calendar-checkin').val(), 'DD/MM/YYYY');
        var CheckOutDate = moment($$('#New-calendar-checkout').val(), 'DD/MM/YYYY');
        var RoomTypeID = 0;

        if (CheckiInDate.isValid() && CheckOutDate.isValid()) {
          var rooms = $$('.roomsteps').text();
          var adults = $$('.gueststeps').text();
          var childrens = $$('.childrensteps').text();
          RoomsList = [];
          RoomsList = await actions.GetReservationRooms(CheckiInDate, CheckOutDate, rooms, adults, childrens, RoomID, RoomTypeID, UserSpecificApiKey);

          if (RoomsList == 'Error') {
            return;
          }

          if (RoomsList == 'No rates found') {
            var toastCheckRates = app.f7.toast.create({
              text: RoomsList,
              closeButton: true,
              closeButtonText: 'Close Me',
              closeButtonColor: 'red'
            });
            toastCheckRates.open();
            return;
          } //pernaw property isAvailable


          for (let i = 0; i < RoomsList.length; i++) {
            if (RoomsList[i].OccupiedRooms >= RoomsList[i].TotalRooms) {
              RoomsList[i].IsAvailable = false;
            } else {
              RoomsList[i].IsAvailable = true;
            }

            RoomsList[i].TotalFree = RoomsList[i].TotalRooms - RoomsList[i].OccupiedRooms;
            RoomsList[i].allocatedRooms = 0;
            RoomsList[i].availableRooms = RoomsList[i].TotalFree;
            RoomsList[i].selectedRateIndex = 0;
          }

          var currency = actions.GetUserCurrency();
          RoomsList = RoomsList.map(item => {
            return { ...item,
              Currency: currency
            };
          });

          for (let index = 0; index < rooms; index++) {
            const Index = index;
            const FilterRooms = [...RoomsList];
            const count = Index + 1;
            const itemsToRemove = NumberOfRooms?.length - rooms;

            if (itemsToRemove > 0) {
              NumberOfRooms.splice(-itemsToRemove);
            }

            let foundIndex = NumberOfRooms.findIndex(room => room.Index === Index);

            if (foundIndex !== -1) {
              NumberOfRooms[foundIndex].FilterRooms = FilterRooms;

              if (NumberOfRooms[foundIndex].SelectedRoom) {
                var selectedRoomRoomTypeID = NumberOfRooms[foundIndex].SelectedRoom?.RoomTypeID;
                let filteredRoom = FilterRooms?.find(room => room.RoomTypeID === selectedRoomRoomTypeID);

                if (filteredRoom) {
                  NumberOfRooms[foundIndex].SelectedRoom = filteredRoom;
                }
              }
            } else {
              NumberOfRooms.push({
                Index,
                FilterRooms,
                SelectedRoom: {},
                count
              });
            }
          }

          await app.f7.request.promise.post(URLS.GetPaymentTypes, {
            PropertyID: loginobject.PropertyID
          }).then(res => {
            PaymentMethods = JSON.parse(res.data);
          });
          self.$setState({
            PaymentMethods: PaymentMethods,
            Rooms: RoomsList,
            NumberOfSelectedRooms: NumberOfRooms
          });
          var countries = [];

          if (RoomsList !== 'undefined' && RoomsList.length > 0) {
            countries = RoomsList[0]?.Countries;
            localStorage.setItem('Countries', JSON.stringify(countries));
            totalSelectedRooms = 0;
            totalPriceStepper = 0;
          }

          self.calculateTotalPriceAndRooms();
        }
      }

      SearchOnOpen(true);
      BlockedRooms(loginobject.PropertyID, CalendarDateFrom, CalendarDateTo);
      var page = e.detail.page; //Segmented Buttons on click

      $$('#Guestbtn').on('click', function () {
        ChangeSegmented(1);
      });
      $$('#Agencybtn').on('click', function () {
        ChangeSegmented(2);
      });
      $$('#Corporatebtn').on('click', function () {
        ChangeSegmented(3);
      });
      $$('#ContBtn').on('click', function () {
        var CalendarDateFrom = new Date(calendarRangeFrom.getValue());
        var CalendarDateFromStr = moment(CalendarDateFrom).format('YYYY-MM-DD');
        var CalendarDateTo = new Date(calendarRangeTo.getValue());
        var CalendarDateToStr = moment(CalendarDateTo).format('YYYY-MM-DD');
        var checkedItems = [];
        var stepperRooms = $$('.roomsteps').text();
        var stepperguests = $$('.gueststeps').text();
        var stepperchild = $$('.childrensteps').text();
        var CalendarDateFrom1 = moment(CalendarDateFrom);
        var CalendarDateToStr1 = moment(CalendarDateTo);
        var Nights = CalendarDateToStr1.diff(CalendarDateFrom1, 'days');
        const selectedRooms = NumberOfRooms.filter(room => {
          const selectedRoom = room.SelectedRoom;
          return selectedRoom && Object.keys(selectedRoom).length > 0;
        });
        const payMethod = $$('#payment-method-selection').val();
        const isPrepay = $$('#isPrepay').prop('checked');
        let prepayAmount = $$('#prepay-amount').val();

        if (prepayAmount) {
          prepayAmount = parseFloat(prepayAmount);
        }

        if (isPrepay && !prepayAmount) {
          var toastWithCustomButton = app.f7.toast.create({
            text: 'Please choose a prepay amount',
            closeButton: true,
            closeButtonText: 'Close Me',
            closeButtonColor: 'red'
          });
          toastWithCustomButton.open();
          return;
        }

        const paymentMethod = {
          pMethod: payMethod,
          isPrepay: isPrepay,
          prepayAmount: prepayAmount
        };
        const isOffer = $$("#OfferTab").hasClass('tab-link-active');
        const source = $$(".source").val();

        if (selectedRooms.length > 0) {
          let label = selectedRooms.length; // Get the label based on selected rooms

          let infoList = [];
          let totalRoomsPrice = 0;
          let numberOfRooms = 0;
          selectedRooms.forEach(room => {
            const selectedRoom = room.SelectedRoom;
            let selectedRate = selectedRoom.selectedRateIndex != undefined ? selectedRoom.Rates[selectedRoom.selectedRateIndex] : selectedRoom.Rates[0]; // Ensure prices are numeric and properly formatted

            let totalPriceFormatted = parseFloat(selectedRate.TotalPrice) % 1 === 0 ? parseFloat(selectedRate.TotalPrice).toFixed(0) : parseFloat(selectedRate.TotalPrice).toFixed(2);
            let infoObject = {
              RateName: selectedRate.RateName,
              RoomTypeName: selectedRoom.RoomTypeName,
              stepperchild: stepperchild,
              stepperguests: stepperguests,
              totalRoomsPrice: totalRoomsPrice,
              // This will be updated correctly after addition
              labelRoomSelected: labelRoomSelected,
              Nights: Nights,
              CalendarDateFromStr: CalendarDateFromStr,
              DateFrom: CalendarDateFromStr,
              CalendarDateToStr: CalendarDateToStr,
              DateTo: CalendarDateToStr,
              RateID: selectedRate.RateID,
              RoomTypeID: selectedRoom.RoomTypeID,
              AllocatedRooms: 1,
              TotalPrice: totalPriceFormatted // Correctly formatted TotalPrice

            };
            infoList.push(infoObject); // Add the total price for the room, ensuring proper formatting

            totalRoomsPrice += parseFloat(selectedRate.TotalPrice);
          });
          numberOfRooms = selectedRooms.length; // Ensure totalRoomsPrice is formatted for storage

          let totalRoomsPriceFormatted = totalRoomsPrice % 1 === 0 ? totalRoomsPrice.toFixed(0) : totalRoomsPrice.toFixed(2);
          localStorage.setItem('ContReservation', JSON.stringify({
            infoList: infoList,
            label: label,
            totalSelectedRooms: numberOfRooms,
            totalPriceStepper: totalRoomsPriceFormatted,
            // Correctly formatted total price
            paymentMethod: paymentMethod,
            isOffer: isOffer,
            source: source
          }));
          app.f7.views.main.router.navigate('/new-reservation-staydetails/', {
            transition: 'f7-parallax'
          });
        } else {
          var toastWithCustomButton = app.f7.toast.create({
            text: 'You should select at least one room to continue',
            closeButton: true,
            closeButtonText: 'Close Me',
            closeButtonColor: 'red'
          });
          toastWithCustomButton.open();
        }
      });
      $$('#UpdateRooms').on('click', async function () {
        var CalendarDateFrom = new Date(calendarRangeFrom2.getValue());
        var CalendarDateFromStr = moment(CalendarDateFrom).format('YYYY-MM-DD');
        var CalendarDateTo = new Date(calendarRangeTo2.getValue());
        var CalendarDateToStr = moment(CalendarDateTo).format('YYYY-MM-DD');
        var comment = $$('textarea').val();
        $$('#Rooms').on('click', function () {});
        var rooms = app.f7.smartSelect.get('#smartselectBlockedRooms').getValue();
        var obj = {
          PropertyID: loginobject.PropertyID,
          DateFrom: CalendarDateFromStr,
          DateTo: CalendarDateToStr,
          Comment: comment,
          RoomCode: rooms,
          UserID: loginobject.UserID
        };
        app.f7.preloader.show();
        await app.f7.request.promise.postJSON(URLS.SubmitRoomBlockedDay, {
          obj
        }).then(res => {
          app.f7.preloader.hide();

          if (res.data == 'ok') {
            var toastBottom = app.f7.toast.create({
              text: ' Rooms blocked succesfully',
              closeTimeout: 2000,
              cssClass: 'toast_green'
            });
            toastBottom.open();
          } else if (res.data == 'unblock') {
            var toastBottom = app.f7.toast.create({
              text: ' Rooms unblocked succesfully',
              closeTimeout: 2000,
              cssClass: 'toast_green'
            });
            toastBottom.open();
          } else if (res.data == 'CantBlock') {
            var toastBottom = app.f7.toast.create({
              text: ' Error for blocking rooms',
              closeTimeout: 2000,
              cssClass: 'toast_red'
            });
            toastBottom.open();
          } else if (res.data == 'InvalidDates') {
            var toastBottom = app.f7.toast.create({
              text: 'Please check the dates',
              closeTimeout: 2000,
              cssClass: 'toast_red'
            });
            toastBottom.open();
          }
        });
      });

      async function BlockedRooms(PropertyID, DateFrom, DateTo) {
        DateFrom = new Date(DateFrom[0]);
        DateTo = new Date(DateTo[0]);
        var DateFromstr = moment(DateFrom).format('YYYY-MM-DD');
        var DateTostr = moment(DateTo).format('YYYY-MM-DD');
        var perm = 0;
        let login = JSON.parse(localStorage.getItem('loginJson'));
        var obj = {
          PropertyID: PropertyID,
          DateFrom: DateFromstr,
          DateTo: DateTostr,
          UserID: login.UserID,
          UserSpecificApiKey: UserSpecificApiKey
        };
        await app.f7.request.promise.postJSON(URLS.GetRoomsForBlock, {
          obj
        }).then(res => {
          app.f7.preloader.hide();
          self.$setState({
            BlockedRooms: res.data
          });
        });
      }

      calendarRangeFrom2.on('close', async () => {
        var CalendarDateFrom = calendarRangeFrom2.getValue();
        var CalendarDateTo = calendarRangeTo2.getValue();
        BlockedRooms(loginobject.PropertyID, CalendarDateFrom, CalendarDateTo);
      });
      calendarRangeTo2.on('close', async () => {
        var CalendarDateFrom = calendarRangeFrom2.getValue();
        var CalendarDateTo = calendarRangeTo2.getValue();
        BlockedRooms(loginobject.PropertyID, CalendarDateFrom, CalendarDateTo);
      });

      function handleChangeNumberOfRooms(rooms) {
        for (let index = 0; index < rooms; index++) {
          const Index = index;
          const FilterRooms = NumberOfRooms[index]?.FilterRooms ? NumberOfRooms[index]?.FilterRooms : RoomsList;
          const itemsToRemove = NumberOfRooms?.length - rooms;

          if (itemsToRemove > 0) {
            NumberOfRooms = NumberOfRooms.slice(0, rooms);
            self.calculateTotalPriceAndRooms();
          }

          const count = Index + 1;
          let foundIndex = NumberOfRooms.findIndex(room => room.Index === Index);

          if (foundIndex !== -1) {// If found, update the FilterRooms data
            //NumberOfRooms[foundIndex].FilterRooms = FilterRooms;
          } else {
            FilterRooms.forEach(room => {
              room.IsAvailable = room.OccupiedRooms < room.TotalRooms;
              room.TotalFree = room.TotalRooms - room.OccupiedRooms;
              room.allocatedRooms = 0;
              room.selected = false;
              room.availableRooms = room.TotalFree;
            });
            NumberOfRooms.push({
              Index,
              FilterRooms,
              count
            });
          }
        }

        self.$setState({
          NumberOfSelectedRooms: NumberOfRooms
        });
      } //Search Button


      $$('.searchbtn').on('click', async function () {
        let isRoomTypeEmpty = false;
        let firstEmptySelector;
        $$('.roomtype').each(function () {
          if (!this.value || this.value === "0") {
            isRoomTypeEmpty = true;

            if (!firstEmptySelector) {
              firstEmptySelector = $$(this).closest('.smart-select');
            }
          }
        }); // If any room type selector is empty, click the first one
        // if (isRoomTypeEmpty && firstEmptySelector) {
        //     firstEmptySelector.click();
        // } else {
        //     SearchOnOpen();
        // }

        SearchOnOpen();
      }); //Rooms

      $$('.roomstep').click(function () {
        if ($$('.roomsteps').text() == 1 && $$(this).hasClass('down') || +$$('.roomsteps').data('max') == +$$('.roomsteps').text() && $$(this).hasClass('up')) return;

        if ($$(this).hasClass('up')) {
          var num = parseInt($$('.roomsteps').text());
          num = num + 1;
          $$('.roomsteps').text(num);
        } else {
          var num = parseInt($$('.roomsteps').text());
          num = num - 1;
          $$('.roomsteps').text(num);
        }

        handleChangeNumberOfRooms(num);
      }); //Childrens

      $$('.childrenstep').click(function () {
        if ($$('.childrensteps').text() == 0 && $$(this).hasClass('down') || +$$('.childrensteps').data('max') == +$$('.childrensteps').text() && $$(this).hasClass('up')) return;

        if ($$(this).hasClass('up')) {
          var num = parseInt($$('.childrensteps').text());
          num = num + 1;
          $$('.childrensteps').text(num);
        } else {
          var num = parseInt($$('.childrensteps').text());
          num = num - 1;
          $$('.childrensteps').text(num);
        }
      }); //Guests

      $$('.gueststep').click(function () {
        if ($$('.gueststeps').text() == 1 && $$(this).hasClass('down') || +$$('.gueststeps').data('max') == +$$('.gueststeps').text() && $$(this).hasClass('up')) return;

        if ($$(this).hasClass('up')) {
          var num = parseInt($$('.gueststeps').text());
          num = num + 1;
          $$('.gueststeps').text(num);
        } else {
          var num = parseInt($$('.gueststeps').text());
          num = num - 1;
          $$('.gueststeps').text(num);
        }
      });
      $$('.chooseroomdiv').show();
      $$('.select-value').on('click', function () {
        var selectedRoom = app.f7.smartSelect.get('.select-value').getValue();
        console.log('thisroom', selectedRoom);
      });
    },

    pageBeforeRemove() {},

    pageAfterIn: function (e, page) {
      var self = this;
      var $ = self.$;
      var instance = app.f7.stepper?.setValue('.room-step-count', 0);
      var today = moment();
      var tomorrow = moment(today).add(1, 'days');
      $$('.select-value').on('click', function () {
        var selectedRoom = app.f7.smartSelect.get('.select-value').getValue();
      });
      totalRoomsPrice = 0;
      labelRoomSelected = 0;
      $('.page-current').on('change', '.checkbox', async function (event) {
        //vriskw to id ton check domation
        let $target = $(event.target);
        let $label = $target.closest('.checkbox');
        var roomId = $label.attr('id'); // me vasi to id vriskw olo to object roomslist opou Roomslist einai to response pou pairnw kai einai global

        let selectedRoom = RoomsList.find(function (roomObj) {
          return roomObj.RoomTypeID == roomId;
        });
        var selecid = '#Numberrooms_' + roomId;
        var numberOfRooms = $$(selecid).text();
        var roomPrice = $label.parent().siblings('.room-price-cnt').find('.roomprice').find('b').text().replace('€ ', '');
        roomPrice = parseInt(roomPrice);
        var ch = $label.find('input');
        var ched = ch.prop('checked');
        var input = $(this).find('.selectedbox');
        var box = input.prop('checked'); //an einai epilegmeno to domatio tou pernaw ena property selected

        if (ched == true) {
          totalRoomsPrice = (totalRoomsPrice + roomPrice) * numberOfRooms;
          labelRoomSelected = labelRoomSelected + 1;
          selectedRoom.selected = true;
        } else {
          labelRoomSelected = labelRoomSelected - 1;
          selectedRoom.selected = false;
        }

        $$('#leball').text(totalSelectedRooms);
      });
      $('.page-current').on('click', '.stepper-raised', function (event) {
        let $target = $(event.target);
        let $step = $target.closest('.item-after').prev().find('span');
        var stepperId = $step.attr('id');
        var roomId = stepperId.split('_')[1];
        let selectedRoom = RoomsList.find(function (roomObj) {
          return roomObj.RoomTypeID == roomId;
        });
        let selectedRate = selectedRoom.selectedRateIndex != undefined ? selectedRoom.Rates[selectedRoom.selectedRateIndex] : selectedRoom.Rates[0];

        if ($target.hasClass('stepper-button-plus')) {
          if (selectedRoom.allocatedRooms === selectedRoom.availableRooms) {
            return;
          }

          selectedRoom.allocatedRooms++;
          selectedRoom.selected = true;
        } else if ($target.hasClass('stepper-button-minus') && selectedRoom.allocatedRooms === 0) {
          return;
        } else {
          selectedRoom.allocatedRooms--;

          if (selectedRoom.allocatedRooms === 0) {
            selectedRoom.selected = false;
          }
        }

        if (selectedRoom.allocatedRooms >= 1) {
          rompricr = '#roomprice_' + roomId;
          $$(rompricr).text(selectedRoom.allocatedRooms * selectedRate.TotalPrice);
        }

        self.calculateTotalPriceAndRooms();
      });
      $('#NewReservationTab').on('click', function (event) {
        app.f7.dialog.confirm('Are you sure you want to change to the Reservation Tab?', function () {
          app.f7.tab.show('#newreservation-tab');
          $$('.toolbar-bottom').show();
          $$('#NewResBlockTitle').html('NEW RESERVATION');
          $$(".tab-link").removeClass('tab-link-active');
          $$("#NewReservationTab").addClass('tab-link-active');
        });
      });
      $('#OfferTab').on('click', function (event) {
        app.f7.dialog.confirm('Are you sure you want to change to the Offer Tab?', function () {
          app.f7.tab.show('#newreservation-tab');
          $$('.toolbar-bottom').show();
          $$('#NewResBlockTitle').html('NEW OFFER');
          $$(".tab-link").removeClass('tab-link-active');
          $$("#OfferTab").addClass('tab-link-active');
        });
      });
      $('#BlockedRoomsTab').on('click', function (event) {
        app.f7.dialog.confirm('Are you sure you want to change to the Block Rooms Tab?', function () {
          $$('.toolbar-bottom').hide();
          $$('#NewResBlockTitle').html('BLOCK ROOMS');
          app.f7.tab.show('#blockrooms-tab');
          $$(".tab-link").removeClass('tab-link-active');
          $$("#BlockedRoomsTab").addClass('tab-link-active');
        });
      });
    }
  },
  id: '1f289eb766',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page data-name=new-reservation-home><!-- Top Navbar --><!-- Top Navbar --><div class=navbar><div class=navbar-bg></div><div class="navbar-inner sliding"><div class=left><a class="link back"><i class="icon icon-back"></i></a></div><div class=title id=NewResBlockTitle>';
      r += Template7Helpers.t.call(ctx_1, 'newreservation', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div></div></div><!----Toolbar bottom--><div class="toolbar toolbar-bottom"><div class=toolbar-inner><div class=row style="height: 100%"><div class="col-40 total-value"><span class="badge custom-badge-black" id=leball>0</span> <span id=prall style="margin-bottom: auto; margin-top: auto">0 </span><span style="margin-bottom: auto; margin-top: auto; margin-left: 5px"><span class=currency-symbol></span></span></div><button id=ContBtn class="col-60 contbtn" style="border: none"><span style="margin-top: 13px; font-size: 15px">';
      r += Template7Helpers.t.call(ctx_1, 'continue', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</span><!-- <button style="margin-top: auto;margin-bottom: auto;"> ';
      r += Template7Helpers.t.call(ctx_1, 'continue', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += ' </button> --></button></div></div></div><!-- Scrollable page content--><div class="page-content newreservationpage"><div style="margin: 15px 0 10px;padding: 0 16px;"><div class="segmented segmented-strong" style="background-color: #3478f5"><a class="button tab-link tab-link-active" style="text-transform: capitalize" id=NewReservationTab>Reservation</a> ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.loginobject?.hasOffers, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += ' <a class="button tab-link" style="text-transform: capitalize" id=OfferTab>Offer</a> ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += ' <a class="button tab-link" style="text-transform: capitalize" id=BlockedRoomsTab>Block Rooms</a> <span class=segmented-highlight></span></div></div><div class=tabs><!--first div--><div class="tab page-content tab-active" id=newreservation-tab><div class=row style="width: 100%"><div class=row style="padding: 10px;"><div class=Div_title>Dates</div><div class="row search-option-row"><span class="col-50 customcol"><input name=checkindate class=custom-input type=text readonly=readonly id=New-calendar-checkin></span><div class=chip-media style="position: absolute; right: 46%; background-color: #222933"><span class=material-icons>chevron_right</span></div><span class="col-50 customcol"><input name=checkoutdate class=custom-input type=text readonly=readonly id=New-calendar-checkout></span></div><div class="row search-option-row"><div class=col-60>';
      r += Template7Helpers.t.call(ctx_1, 'guests', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div><div class="col-40 search-button-wrapper"><div class="col-33 gueststep step down"><span class=material-icons>remove</span></div><div class=col-33><span class="steps gueststeps" data-min=1 data-max=30>1</span></div><div class="col-33 gueststep step up"><span class=material-icons>add</span></div></div></div><div class="row search-option-row"><div class=col-60>';
      r += Template7Helpers.t.call(ctx_1, 'childrens', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div><div class="col-40 search-button-wrapper"><div class="col-33 childrenstep step down"><span class=material-icons>remove</span></div><div class=col-33><span class="steps childrensteps" data-min=0 data-max=30>0</span></div><div class="col-33 childrenstep step up"><span class=material-icons>add</span></div></div></div><div class="row search-option-row"><div class=col-60>Rooms</div><div class="col-40 search-button-wrapper"><div class="col-33 roomstep step down"><span class=material-icons>remove</span></div><div class=col-33><span class="steps roomsteps" data-min=1 data-max=30>1</span></div><div class="col-33 roomstep step up"><span class=material-icons>add</span></div></div></div><div class="block row"><div class=col-100 style="margin-bottom: 5px;font-weight: 800;">Select Source</div><a class="col-100 search-button-wrapper item-link smart-select smart-select-init select-value" data-open-in=sheet><select class=source><option selected=selected value=0>Select a source</option>';
      r += Template7Helpers.each.call(ctx_1, ctx_1.Sources, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<option value=';
          r += c(ctx_2.Value, ctx_2);
          r += '>';
          r += c(ctx_2.Text, ctx_2);
          r += '</option>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</select><div class=item-content style="width: 100%"><div class=item-inner style="display: flex; width: 100%; justify-content: center"><div class=item-title></div><span class=material-icons>expand_more</span></div></div></a></div><div class=row style="padding:10px 10px 0px 10px;"><button class="col button button-small button-outline searchbtn color-blue">';
      r += Template7Helpers.t.call(ctx_1, 'search', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</button></div></div></div>';
      r += Template7Helpers.each.call(ctx_1, ctx_1.NumberOfSelectedRooms, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<div class="block row"><div class=col-100 style="margin-bottom: 5px;font-weight: 800;">';
          r += c(ctx_2.count, ctx_2);
          r += ') Room Type or Rental</div><a id=room-type-selector_';
          r += c(ctx_2.Index, ctx_2);
          r += ' @smartselect:close=ShowRoom(';
          r += c(ctx_2.Index, ctx_2);
          r += ') class="room-cat-filter col-100 search-button-wrapper item-link smart-select smart-select-init select-value" data-open-in=sheet><select id=room-cat-filter-selection_';
          r += c(ctx_2.Index, ctx_2);
          r += ' name=roomtype_';
          r += c(ctx_2.Index, ctx_2);
          r += ' class=roomtype><option selected=selected value=0>Select a room</option>';
          r += Template7Helpers.each.call(ctx_2, ctx_2.FilterRooms, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += ' ';
              r += Template7Helpers.if.call(ctx_3, ctx_3.IsAvailable, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '<option value=';
                  r += c(ctx_4.RoomTypeID, ctx_4);
                  r += '>';
                  r += c(ctx_4.RoomTypeName, ctx_4);
                  r += '</option>';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += ' ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</select><div class=item-content style="width: 100%"><div class=item-inner style="display: flex; width: 100%; justify-content: center"><div class=item-title></div><span class=material-icons>expand_more</span></div></div></a></div><div class=chooseroomdiv id=room-display-wapper_';
          r += c(ctx_2.Index, ctx_2);
          r += ' hidden><div class=block style="margin-bottom: 5px"><div class=row id=room-display_';
          r += c(ctx_2.Index, ctx_2);
          r += '>';
          r += Template7Helpers.if.call(ctx_2, ctx_2.SelectedRoom, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += ' ';
              r += Template7Helpers.if.call(ctx_3, ctx_3.SelectedRoom.IsAvailable, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '<div class=row><div data-index=';
                  r += c(ctx_4.Index, ctx_4);
                  r += ' data-room-type-id=';
                  r += c(ctx_4.SelectedRoom.RoomTypeID, ctx_4);
                  r += '><div class=row><div id=box-btn_';
                  r += c(ctx_4.Index, ctx_4);
                  r += ' style="width: 100%" @click=toggleBox(';
                  r += c(ctx_4.Index, ctx_4);
                  r += ')><span class=material-icons>expand_less</span> <b>Price <span id=display-price_';
                  r += c(ctx_4.Index, ctx_4);
                  r += '_';
                  r += c(ctx_4.SelectedRoom.RoomTypeID, ctx_4);
                  r += '>';
                  r += c(ctx_4.SelectedRoom.Rates[0].TotalPrice, ctx_4);
                  r += '</span> <span>';
                  r += c(ctx_4.SelectedRoom.Currency, ctx_4);
                  r += '</span></b></div><div style="display: flex; width: 100%; flex-direction: column" class="box expanded" id=box_';
                  r += c(ctx_4.Index, ctx_4);
                  r += '><div class=box-row><div class=flex style="width: 50%"><a href=# @smartselect:close=updateHeroOpen(';
                  r += c(ctx_4.SelectedRoom.RoomTypeID, ctx_4);
                  r += ',';
                  r += c(ctx_4.Index, ctx_4);
                  r += ') name=rate_';
                  r += c(ctx_4.Index, ctx_4);
                  r += ' class="roomid_';
                  r += c(ctx_4.Index, ctx_4);
                  r += '_';
                  r += c(ctx_4.SelectedRoom.RoomTypeID, ctx_4);
                  r += ' item-link smart-select smart-select-init select-value" data-open-in=sheet><select name=rate class=rateid>';
                  r += Template7Helpers.each.call(ctx_4, ctx_4.SelectedRoom.Rates, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '<option value="';
                      r += c(ctx_4.RoomTypeID, ctx_5);
                      r += '-';
                      r += c(ctx_5.RateID, ctx_5);
                      r += '-';
                      r += c(ctx_5.TotalPrice, ctx_5);
                      r += ' ">';
                      r += c(ctx_5.RateName, ctx_5);
                      r += '</option>';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [ctx_3, ctx_2, ctx_1]
                  });
                  r += '</select><div class=item-content><div class=item-inner style="display: flex"><div class="item-title selectedrates"></div><span class=material-icons>expand_more</span></div></div></a></div><div class="flex room-price-cnt" style="width: 50%; align-items: flex-end"><span class="color-darkgreen roomprice"><input id=roompriceday_';
                  r += c(ctx_4.Index, ctx_4);
                  r += '_';
                  r += c(ctx_4.SelectedRoom.RoomTypeID, ctx_4);
                  r += ' class=room-price-value value=';
                  r += c(ctx_4.SelectedRoom.Rates[0].PricePerNight, ctx_4);
                  r += ' data-changevalue=false type=number @change=calculatePrices(';
                  r += c(ctx_4.Index, ctx_4);
                  r += ') @keyup=changeValueKeyUp> <span class=price-wrapper>Per day ';
                  r += c(ctx_4.SelectedRoom.Currency, ctx_4);
                  r += '</span></span></div></div><div class=box-row><div class=flex style="width: 50%">Cleaning cost</div><div class="flex room-price-cnt" style="width: 50%; align-items: flex-end"><span class="color-darkgreen roomprice"><input id=roompriceclean_';
                  r += c(ctx_4.Index, ctx_4);
                  r += '_';
                  r += c(ctx_4.SelectedRoom.RoomTypeID, ctx_4);
                  r += ' class=room-price-value value=';
                  r += c(ctx_4.SelectedRoom.Rates[0].CleaningPrice, ctx_4);
                  r += ' data-changevalue=false type=number @change=calculatePrices(';
                  r += c(ctx_4.Index, ctx_4);
                  r += ') @keyup=changeValueKeyUp></span></div></div><div class=box-row><div class=flex style="width: 50%">Discount %</div><div class="flex room-price-cnt" style="width: 50%; align-items: flex-end"><span class="color-darkgreen roomprice"><input id=roompricediscount_';
                  r += c(ctx_4.Index, ctx_4);
                  r += '_';
                  r += c(ctx_4.SelectedRoom.RoomTypeID, ctx_4);
                  r += ' class=room-price-value value=';
                  r += c(ctx_4.SelectedRoom.Rates[0].Discount, ctx_4);
                  r += ' type=number data-changevalue=false @change=calculatePrices(';
                  r += c(ctx_4.Index, ctx_4);
                  r += ') @keyup=changeValueKeyUp></span></div></div><div class=box-row><div class=flex style="width: 50%">Total price</div><div class="flex room-price-cnt" style="width: 50%; align-items: flex-end"><span class="color-darkgreen roomprice">';
                  r += Template7Helpers.if.call(ctx_4, ctx_4.SelectedRoom.Rates?.length, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += ' <input id=roomprice_';
                      r += c(ctx_5.Index, ctx_5);
                      r += '_';
                      r += c(ctx_5.SelectedRoom.RoomTypeID, ctx_5);
                      r += ' class=room-price-value value=';
                      r += c(ctx_5.SelectedRoom.Rates[0].TotalPrice, ctx_5);
                      r += ' data-changevalue=false type=number @change=calculatePrices(';
                      r += c(ctx_5.Index, ctx_5);
                      r += ',true) @keyup=changeValueKeyUp> ';
                      return r;
                    },
                    inverse: function (ctx_5, data_5) {
                      var r = '';
                      r += ' <b class="">No Rates Available</b> ';
                      return r;
                    },
                    root: root,
                    parents: [ctx_3, ctx_2, ctx_1]
                  });
                  r += '</span></div></div></div></div></div></div>';
                  r += Template7Helpers.if.call(ctx_4, ctx_4.SelectedRoom.Rates?.length, {
                    hash: {},
                    data: data_4 || {},
                    fn: function empty() {
                      return '';
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [ctx_3, ctx_2, ctx_1]
                  });
                  return r;
                },
                inverse: function (ctx_4, data_4) {
                  var r = '';
                  r += '<div class=row><div class=rooms-not-availiable data-index=';
                  r += c(ctx_4.Index, ctx_4);
                  r += ' data-room-type-id=';
                  r += c(ctx_4.RoomTypeID, ctx_4);
                  r += '><div class=row><div class=flex style="width: 50%" id=';
                  r += c(ctx_4.RoomTypeID, ctx_4);
                  r += '><span><b>';
                  r += c(ctx_4.SelectedRoom.RoomTypeName, ctx_4);
                  r += ' </b></span><a href=# @smartselect:close=updateHeroOpen(';
                  r += c(ctx_4.SelectedRoom.RoomTypeID, ctx_4);
                  r += ') name=rate_';
                  r += c(ctx_4.Index, ctx_4);
                  r += ' class="roomid_';
                  r += c(ctx_4.Index, ctx_4);
                  r += '_';
                  r += c(ctx_4.RoomTypeID, ctx_4);
                  r += ' item-link smart-select smart-select-init select-value" data-open-in=sheet><select name=rate class=rateid>';
                  r += Template7Helpers.each.call(ctx_4, ctx_4.SelectedRoom.Rates, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '<option value="';
                      r += c(ctx_4.RoomTypeID, ctx_5);
                      r += '-';
                      r += c(ctx_5.RateID, ctx_5);
                      r += '-';
                      r += c(ctx_5.TotalPrice, ctx_5);
                      r += ' ">';
                      r += c(ctx_5.RateName, ctx_5);
                      r += '</option>';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [ctx_3, ctx_2, ctx_1]
                  });
                  r += '</select><div class=item-content><div class=item-inner style="display: flex"><div class="item-title selectedrates"></div><span class=material-icons>expand_more</span></div></div></a><span>Max: ';
                  r += c(ctx_4.SelectedRoom.MaxAdults, ctx_4);
                  r += ' + ';
                  r += c(ctx_4.SelectedRoom.MaxChildren, ctx_4);
                  r += '</span></div><div class="flex room-price-cnt" style="width: 50%; align-items: flex-end"><span class="color-darkgreen roomprice"><span style="font-weight: 700">';
                  r += c(ctx_4.SelectedRoom.Currency, ctx_4);
                  r += '</span> ';
                  r += Template7Helpers.if.call(ctx_4, ctx_4.SelectedRoom.Rates?.length, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += ' <b>';
                      r += c(ctx_5.SelectedRoom.Rates[0].TotalPrice, ctx_5);
                      r += '</b> ';
                      return r;
                    },
                    inverse: function (ctx_5, data_5) {
                      var r = '';
                      r += ' <b>No Rates Available</b> ';
                      return r;
                    },
                    root: root,
                    parents: [ctx_3, ctx_2, ctx_1]
                  });
                  r += '</span></div></div></div></div>';
                  return r;
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += ' ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</div></div></div>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += ' ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.hasSelectedRoom, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<hr><div class=block style="margin-top: 15px"><div class=row><div style="width: 48%"><div>Prepay</div><label class="item-checkbox item-checkbox-icon-start item-content prepay-wrapper"><input type=checkbox id=isPrepay value=1> <i style="margin: 6px" class="icon icon-checkbox"></i><div style="border-left: 2px solid #ebebeb"><input style="width: 100%; height: 100%" id=prepay-amount type=number></div></label></div><div style="width: 48%"><div>Payment method</div><a id=payment-method-selector class="col-100 search-button-wrapper item-link smart-select smart-select-init select-value" data-open-in=sheet><select id=payment-method-selection name=payment-method><option selected=selected value=0>No option</option>';
          r += Template7Helpers.each.call(ctx_2, ctx_2.PaymentMethods, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '<option value=';
              r += c(ctx_3.Key, ctx_3);
              r += '>';
              r += c(ctx_3.Val, ctx_3);
              r += '</option>';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</select><div class=item-content style="width: 100%"><div class=item-inner style="display: flex; width: 100%; justify-content: center"><div class=item-title></div><span class=material-icons>expand_more</span></div></div></a></div></div></div>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div><!--second div--><div class="tab page-content" id=blockrooms-tab><div class=block-title>Dates</div><div class=block><div class=row><span class="col-50 customcol"><input name=checkindate class=custom-input type=text readonly=readonly id=block-calendar-From></span><div class=chip-media style="position: absolute; right: 46%; background-color: #222933"><span class=material-icons>chevron_right</span></div><span class="col-50 customcol"><input name=checkindate class=custom-input type=text readonly=readonly id=block-calendar-To></span></div></div><div class=block-title>Room Number</div><div class=block><div class=row><span class="col-100 customcol"><!-- ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.BlockedRooms, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                                  <select name="mac-windows" >\n                                          <option value="';
          r += c(ctx_2.Value, ctx_2);
          r += '" >';
          r += c(ctx_2.Text, ctx_2);
          r += '</option> <div class="item-content">\n                                              <div class="item-inner">\n                                                <div class="item-title"></div>\n                                              </div>\n                                            </div></select>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += ' --><!-- <a class=" list item-link smart-select" > \n                                        <select name="mac-windows" id="blocked" >\n                                          \n                                          <div class="item-content">\n                                              <div class="item-inner">\n                                                <div class="item-title">tata</div>\n                                              </div>\n                                            </div>\n                                            \n                                        \n                                      </select>\n                                        \n                                        </a>\n                                       --> <a href=# class="item-link smart-select smart-select-init" id=smartselectBlockedRooms data-open-in=popup><select name=days3 id=blocked multiple=multiple>';
      r += Template7Helpers.each.call(ctx_1, ctx_1.BlockedRooms.RoomsList, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<option value=';
          r += c(ctx_2.Key, ctx_2);
          r += '>';
          r += c(ctx_2.Val, ctx_2);
          r += '</option>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</select><div class=item-content><div class=item-inner><div class=item-title>Blocked Rooms</div></div></div></a></span></div></div><div class=block-title>Blocked Room Comments</div><div class=block><div class=row><span class="col-100 customcol"><!-- <a class="item-link smart-select smart-select-init" data-open-in="sheet">\n                                        <select name="mac-windows">\n                                          <option value="mac" selected>-</option>\n                                          <option value="windows">room 2</option>\n                                        </select>\n                                        <div class="item-content">\n                                          <div class="item-inner">\n                                            <div class="item-title"></div>\n                                          </div>\n                                        </div>\n                                      </a> --> <a href=# class="item-link smart-select smart-select-init takecommentclass" data-open-in=popup><select name=days id=blockedroomcomments>';
      r += Template7Helpers.each.call(ctx_1, ctx_1.BlockedRooms.CommentsList, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<option value=';
          r += c(ctx_2.Key, ctx_2);
          r += '>';
          r += c(ctx_2.Val, ctx_2);
          r += '</option>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</select><div class=item-content><div class=item-inner><div class=item-title id=takecomment>Blocked Room Comments</div></div></div></a></span></div></div><div class=block-title>Comments</div><div class=block><div class=row><span class="col-100 customcol"><textarea class=resizable id=blocktext placeholder="" style="width: 100%; padding-left: 5px; padding-right: 5px"></textarea></span></div></div><div class=block><div class=row><div class=col-70><button class="col button button-outline color-blue" id=UpdateRooms>Update Room Status</button></div><div class=col-30><button id=cancelbtn class="col button button-fill cancelreserv">Cancel</button></div></div></div></div></div></div><div style="display: none"><div id=clickme></div><input hidden id=hIndex value=0></div></div>';
      return r;
    }(this);
  },

  style: `
    .tab-link {
        color: white !important;
    }

    .prepay-wrapper {
        display: flex;
        border: 2px solid #ebebeb;
        border-radius: 6px;
    }

    .box-row {
        width: 100%;
        display: flex;
        align-items: center;
    }

    .box {
        overflow: hidden;
        height: 0;
        transition: height 0.3s ease-out;
    }

    .expanded {
        height: auto;
    }

    .collapsed {
        height: 0;
    }

    .roomprice {
        text-align: right;
        font-size: 15px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: row-reverse;
    }

    .price-wrapper {
        font-weight: 700;
        width: 50%;
    }

    .room-price-value {
        width: 40% !important;
        border: 2px solid #ebebeb !important;
        border-radius: 5px !important;
        padding: 8px 10px !important;
        margin: 3px 0 !important;
    }

    .price-input {
        border: 1px solid #888888 !important;
        width: 50%;
        padding: 5px 10px !important;
        border-radius: 5px !important;
    }

    #room-type-selector {
        margin-bottom: 15px;
    }

    #room-type-selector .item-content {
        width: 100%;
    }

    #room-type-selector .item-content .item-inner {
        justify-content: space-between;
    }

    .search-button-wrapper {
        display: flex;
        border: 2px solid #ebebeb;
        padding: 5px 2px;
        border-radius: 6px;
        align-items: center;
    }

    .search-option-row {
        display: flex;
        justify-content: space-between;
        margin: 5px 0 !important;
    }

    .custom-stepper-wrapper {
        display: flex;
        width: 100%;
        justify-content: space-between;
        align-items: center;
    }

    .custom-stepper-buttons-wrapper {
        display: flex;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
        border-radius: 5px;
    }

    .custom-stepper-btn {
        background: none;
        border: 1px solid rgba(0, 0, 0, 0.12);
        font-size: 17px;
        color: rgb(0, 122, 255);
        font-weight: 700;
        width: 40px;
        line-height: 26px;
        transition-duration: 0.2s;
    }

    .custom-stepper-btn.custom-plus {
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
    }

    .custom-stepper-btn.custom-minus {
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
    }

    .customcol {
        background-color: #3478f5;
        line-height: 35px;
        border-radius: 5px;
    }

    .Div_title {
        position: relative;
        overflow: hidden;
        margin: 0;
        white-space: var(--f7-block-title-white-space);
        text-overflow: ellipsis;
        text-transform: var(--f7-block-title-text-transform);
        color: var(--f7-block-title-text-color);
        font-size: var(--f7-block-title-font-size, inherit);
        font-weight: var(--f7-block-title-font-weight);
        line-height: var(--f7-block-title-line-height);
        margin-top: 0px;
        margin-left: 0px;
        margin-right: calc(var(--f7-block-padding-horizontal) + var(--f7-safe-area-right));
    }

    .item-after {
        padding-left: 0px;
        padding-right: 0px;
    }

    .newreservationpage .button-fill {
        background-color: #0077ca;
    }

    .tab-link-active {
        color: #0077ca !important;
        font-weight: 700;
    }

    .steps {
        display: inline-block;
        text-align: center;
        color: #0077ca;
        width: 100%;
        font-size: 16px;
        font-weight: 700;
    }

    .step {
        display: inline-block;
        width: 100%;
        text-align: center;
    }

    .material-icons {
        vertical-align: middle;
    }

    .rooms-not-availiable .room-price-cnt .custom-badge {
        background-color: red;
    }

    #smartselectBlockedRooms .item-inner,
    .takecommentclass .item-title,
    #blocktext {
        color: white;
    }

    .md .navbar a.link {
        color: black;
    }
`,
  styleScoped: false
};
    